// Tiny shared store: is the pinned homepage Hero sequence currently in progress?
type Listener = (active: boolean) => void;

let heroActive = false;
const listeners = new Set<Listener>();

export function setHeroActive(next: boolean) {
  if (next === heroActive) return;
  heroActive = next;
  listeners.forEach((l) => l(next));
}

export function getHeroActive() {
  return heroActive;
}

export function subscribeHeroActive(l: Listener) {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}